import ElementBound from '../core/ElementBound';

export default class extends ElementBound {
    constructor(element) {
        super(element);
        if (element.attr('data-expandedviewrows')) {
            this.initializeExpandedViewRows(
                Number(element.attr('data-expandedviewrows')),
            );
        }
    }

    initializeExpandedViewRows(visibleRows) {
        const table = this._element;
        const totalRows = table.find('> div').length;

        table.find('> div').each(function () {
            if ($(this).index() + 1 > visibleRows) {
                $(this).addClass('expanded-view').hide();
            }
        });

        if (totalRows > visibleRows) {
            const control = this.getToggleExpandedViewControlElement();
            table.append(control);

            const button = control.find('a');
            button.html(button.data('show-more'));

            const _this = this;
            button.click(function () {
                _this.toggleExpandedView($(this));
            });
        }
    }

    toggleExpandedView(button) {
        const animationTime = 120;

        if (button.html() === button.data('show-more')) {
            this._element
                .find('.expanded-view')
                .show(animationTime, function () {
                    button.html(button.data('show-less'));
                });
        } else {
            this._element
                .find('.expanded-view')
                .hide(animationTime, function () {
                    button.html(button.data('show-more'));
                });
        }
    }

    getToggleExpandedViewControlElement() {
        return $(`
            <div class="table-row-toggle-expanded-view">
                <div><a data-show-less="Show less..." data-show-more="Show more..."></a></div>
            </div>
        `);
    }
}
